<template>
  <div class="signIn"> 
    <img v-bind:src="img" alt="banner" style="width:100%">
    <div class='signinPhone'>
      <el-button type="primary" v-if="showup" class="signinBtn" v-on:click="downloadApp()">{{getcode}}</el-button>
      <a class="downloadApp" v-if="showudo" v-bind:href="hrefs">下载拼任务APP</a>
    </div>
    
    <div class="stipulate">
      <h3><img src="/static/img/share_ic_rules.png" alt="">领取细则：</h3>
      <ul>
        <li>{{getcodeList}}</li>
        <li>2.完成任务后即领取成功；</li>
        <li>3.同一手机设备, 仅能领取一次；</li>
        <li>4.任何用户作弊行为一经确认, 奖励归零。</li>
      </ul>
    </div>
  </div>
  
</template>

<script>
  import { Require } from './components/api/fetch.js';
  import md5 from 'md5';
  import ajax from 'ajax';
  import { url_latestVersion } from './components/api/api.js';
  import { Message } from 'element-ui';
  import { MessageBox } from 'element-ui';

  export default {
    data :function(){
      return{
        img:'/static/img/share_img_banner.png',
        phoneNumber: '',//手机号
        verificationCode:'',//验证码
        getcode:'下载拼任务App',
        getcodeList:'1.仅首次下载注册用户可以领取；',
        disabledBtn:false,
        token:'',
        shareType:'',//分享类型【1：问卷；2：小任务、邀请中心】
        version:'',//app版本号
        nonce_str:'',
        sign:'',
        getcodes:99,
        Codes:'',
        money:'1',
        showup:true,
        showudo:false,
        hrefs:'',
      }
  },
  // 方法，只要调用它，函数就会执行
  methods: {
      // 获取url后的参数
      GetRequest:function(){  
         const url = location.search; //获取url中"?"符后的字串  
         const theRequest = new Object();  
         if (url.indexOf("?") != -1) {  
            const str = url.substr(1);  
            var strs = str.split("&");
            for(var i = 0; i < strs.length; i++) {  
               theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);  
            }  
         }  
         return theRequest;  
      },
      getOs:function(){  
        var OsObject = "";  
         if(navigator.userAgent.indexOf("MSIE")>0) {  
              return "MSIE";  
         }  
         if(navigator.userAgent.indexOf("Firefox")>0){  
              return "Firefox";  
         }  
         if(navigator.userAgent.indexOf("Safari")>0) {  
              return "Safari";  
         }   
         if(navigator.userAgent.indexOf("Camino")>0){  
              return "Camino";  
         }  
         if(navigator.userAgent.indexOf("Gecko/")>0){  
              return "Gecko";  
         } 
      },
      isIos:function(){
        const that=this
         var u = navigator.userAgent, app = navigator.appVersion;
          var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          if (isIOS) {
              $.ajax({
                url:'https://back.taidu8.com/downloadAppVersion/v2/latestVersion?source=4',
                type:"get",
                dataType:"json",
                success:function(result){
                    console.log(result)
                    if(result.msg == 'SUCCESS'){
                      that.hrefs = 'itms-services://?action=download-manifest&url='+result.rows.downloadurl
                      console.log(that.hrefs)
                    }else{
                      // alert('获取下载地址失败，请稍后再试')
                      this.$message({
                        message: '验获取下载地址失败，请稍后再试',
                        type: 'error',
                        center: true
                      });
                    }
                  }
              });
      　　　　//这个是ios操作系统
             // $('.down-wrans-info').html('当前仅支持安卓版本')
             // this.getcode=''
             
             this.getcodeList='1.仅首次下载注册用户可以领取；' 
             this.showup = false;
             this.showudo = true;  
          }
      },
      // 获取url后的参数
      GetRequest:function(){  
         const url = location.search; //获取url中"?"符后的字串  
         const theRequest = new Object();  
         if (url.indexOf("?") != -1) {  
            const str = url.substr(1);  
            var strs = str.split("&");
            for(var i = 0; i < strs.length; i++) {  
               theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);  
            }  
         }  
         return theRequest;  
      },
      downloadApp:function(){
        const that=this
         var u = navigator.userAgent, app = navigator.appVersion;
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
          var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          if(isAndroid) {
               //判断是否微信登陆
              function isWeiXin() {
              var ua = window.navigator.userAgent.toLowerCase();
              if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
                } else {
                return false;
                }
              }
              if(isWeiXin()){
                // alert(" 是来自微信内置浏览器")
                // $('.down-wrans-info').html('点击右上角在浏览器中打开')
                this.$alert('点击右上角在浏览器中打开', '', {
                  confirmButtonText: '确定',
                  callback: action => {
                    
                  }
                });
              }else{
                // 获取下载APP链接
                // if(that.getOs() == 'Firefox') {
                  $.ajax({
                    url:'https://back.taidu8.com/downloadAppVersion/v2/latestVersion?source=2',
                    type:"get",
                    dataType:"json",
                    success:function(result){
                        console.log(result)
                        if(result.msg == 'SUCCESS'){
                          window.location.href=result.rows.downloadurl
                        }else{
                          // alert('获取下载地址失败，请稍后再试')
                          this.$message({
                            message: '验获取下载地址失败，请稍后再试',
                            type: 'error',
                            center: true
                          });
                        }
                      }
                   });
               
              }
          }
          if (isIOS) {
            
      　　　　
          }
      }
    }, 
    // 计算属性
    computed:{

    },
    // 监听属性
    watch: {

    },
    //创建之前
    beforeCreate : function(){
      // console.log('创建之前');
    },
    //创建完成
    created : function(){
      // console.log('创建vue对象完成');
    },
    //挂载之前
    beforeMount : function(){
      // console.log('挂载之前');
    },
    //挂载成功
    mounted : function(){
      // let ;
      // 获取URL中的参数
      // const GetRequest = this.GetRequest()
      // this.money = GetRequest.money
      this.isIos()
      
    
    },
    //更新之前
    beforeUpdate : function(){
      // console.log('更新之前');
    },
    //更新完成
    updated : function(){
      // console.log('更新完成');
    },
    //销毁之前
    beforeDestroy : function(){
      // console.log('销毁之前');
    },
    //销毁
    destroyed : function(){
      // console.log('销毁完成');
    }
  }
</script>

<style>
  *{margin:0;padding:0;}
  input[type="number"]:focus{border:1px solid #fff;}
  .signinPhone{
    padding:5px 16px 20px;
    text-align:left;
    position: relative;
  }
  .downloadApp{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
    width:100%;
    margin-top: 20px;
    background-color: #fea733;
    border-color: #fea733;
    margin-left: 0px;
    display:block;
    text-decoration:none;
    color:#fff;
  }
  .stipulate{
    padding:10px 20px;
    text-align: left;
  }
  .stipulate h3{
    position: relative;
    padding-left: 30px;
    box-sizing:border-box;
    color:#fea93b;
    font-weight: 500;
  }
  .stipulate img{
    width: 20px;
    position: absolute;
    left:0px;
    top:0px;
  }
  .stipulate ul{
    list-style: none;
    padding-top:8px;
  }
  .stipulate ul li{
    padding:3px 3px 3px 0;
    color:#a3a3a3;
  }
  .signIn .signinPhone .signinBtn{
    width:100%;
    margin-top: 20px;
    background-color: #fea733;
    border-color: #fea733;
    margin-left: 0px;
  }
  .signinPhone .el-button.is-disabled:hover {
    color: #f9ac50;
    cursor: not-allowed;
  }
  #app .el-message {
    width: 68%;
    min-width: 68%;
  }
  .award{
    width:68%;
    margin:0 auto;
    position: relative;
  }
  .award img{
    width:100%;
  }
  .award div{
    position: absolute;
    left: 0;
    top:0;
    width:100%;
    text-align:center;
    padding-top:11.5%;
  }
  .award div p:nth-child(1){
    font-size: 22px;
    color: #e64340;
  }
  .award div p:nth-child(2){
    font-size: 16px;
  }
  .award div p:nth-child(3){
    font-size: 28px;
    color: #e64340;
  }
  body .el-message-box{
    width: 80%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue